import { apiFetch } from '../api';

// 409 beim Speichern (Optimistic Locking): jemand anderes hat den Lead zwischenzeitlich
// gespeichert. Aktuellen Stand nachladen, damit der nächste Speichern-Klick mit dem
// frischen updated_at durchgeht statt endlos erneut 409 zu liefern.
export const CONFLICT_REFRESHED_MSG = 'Der Lead wurde zwischenzeitlich von jemand anderem geändert. Der aktuelle Stand wurde geladen — deine Eingaben sind erhalten. Erneut speichern übernimmt sie auf den neuen Stand.';

export async function fetchFreshLead(id, authHeader) {
  try {
    const res = await apiFetch(`/api/leads/${id}`, { headers: authHeader });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

// Nachgeladener Stand, außer die Eltern-Komponente liefert inzwischen einen neueren
export function newerLead(fresh, prop) {
  if (!fresh) return prop;
  return (prop.updated_at ?? '') > (fresh.updated_at ?? '') ? prop : fresh;
}
